import { defineStore } from "pinia";
import type { UserActivity } from "@/Domain/UserActivity";
import { handleResponsePromiseAsync } from "@/shared/helpers/apiHelper";
import { api } from "@/api";

export const useActivityStore = defineStore("activity", {
  state: () => {
    return {
      activityId: "",
      activeUsers: [] as UserActivity[],
      activityTimer: 0,
      updateInterval: 55000, // 55 seconds
    };
  },
  actions: {
    setActivityId(activityId: string) {
      this.activityId = activityId;
      this.setTimer();
      this.updateActivityAsync();
    },
    setTimer() {
      if (this.activityTimer) {
        clearInterval(this.activityTimer);
      }

      this.activityTimer = window.setInterval(() => {
        this.updateActivityAsync();
      }, this.updateInterval);
    },
    async updateActivityAsync() {
      return await handleResponsePromiseAsync(
        api.post("Activity", {
          ActivityId: this.activityId,
        }),
        (data) => {
          this.activeUsers = data;
        },
        "useActivityStore.ts",
        "updateActivityAsync"
      );
    },
  },
});
